const commonOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: { grid: { display: false }, ticks: { maxTicksLimit: 10, autoSkipPadding: 10 , font: { family: 'Saira'}} },
        y: { type: 'linear', position: 'left', title: { display: true, text: 'Streamflow (cms)', font: { family: 'Saira'}}, min: 0, grid: { display: false }, beginAtZero: true, ticks: { font: {family: 'Saira'}} /* NO MAX */ },
        y1: { type: 'linear', position: 'right', title: { display: true, text: 'SWE (mm)', font: { family: 'Saira'}}, min: 0, grid: { drawOnChartArea: false }, beginAtZero: true, ticks: { font: {family: 'Saira'}} /* NO MAX */ }
    },
    plugins: {
        legend: {
            position: 'top',
            labels: {
              usePointStyle: true,
              font: {
                  family: 'Saira' // Set font to Saira for legend labels
              }, 
              filter: function (legendItem) {
                  return !['75th Percentile Range', '95th Percentile Range'].includes(legendItem.text);
              },
            },
        },
        tooltip: {
          mode: 'index',
          intersect: false,
          titleFont: {
            family: 'Saira' // Set font to Saira for tooltip title
          },
          bodyFont: {
            family: 'Saira' // Set font to Saira for tooltip body
          },
          callbacks: {
              // Optional: Default title callback (shows the x-axis label)
              title: function(tooltipItems) {
                    if (tooltipItems.length > 0) {
                        // Display the date (label) as the title
                        return tooltipItems[0].label || '';
                    }
                    return '';
                },
              // Use the label callback to filter items and format output
              label: function(context) {
                // context contains dataset, dataIndex, formattedValue etc.
                const datasetLabel = context.dataset.label || '';

                // Return null to hide specific datasets from tooltip body
                if (datasetLabel === '95th Percentile Range' || datasetLabel === '75th Percentile Range') {
                    return null;
                }

                // Format the label string for visible datasets
                let label = datasetLabel;
                if (label) {
                    label += ': ';
                }
                  // Use the formattedValue provided by Chart.js
                if (datasetLabel === '25th-75th Percentile Range') {
                // Find the corresponding 75th percentile value
                    const upperRangeDataset = context.chart.data.datasets.find(ds => ds.label === '75th Percentile Range');
                    if (upperRangeDataset && upperRangeDataset.data[context.dataIndex] !== null) {
                        const upperValue = context.chart.tooltip.dataPoints.find(dp => dp.dataset.label === '75th Percentile Range').formattedValue;
                        label = `25th-75th Percentile Range: ${context.formattedValue} - ${upperValue}`;
                    } else {
                        label = `25th-75th Percentile Range: ${context.formattedValue} - N/A`;
                    }
                } else if (datasetLabel === '5th-95th Percentile Range') {
                    // Find the corresponding 75th percentile value
                    const upperRangeDataset = context.chart.data.datasets.find(ds => ds.label === '95th Percentile Range');
                    if (upperRangeDataset && upperRangeDataset.data[context.dataIndex] !== null) {
                        const upperValue = context.chart.tooltip.dataPoints.find(dp => dp.dataset.label === '95th Percentile Range').formattedValue;
                        label = `5th-95th Percentile Range: ${context.formattedValue} - ${upperValue}`;
                    } else {
                        label = `5th-95th Percentile Range: ${context.formattedValue} - N/A`;
                    }
                } else if (context.parsed.y !== null) {
                label += context.formattedValue;
                }
                

                    return label;
              }
              // You can add other callbacks here if needed (e.g., beforeLabel, afterLabel)
          }
      },
      filler: { 
          propagate: true 
      }
    }
  };

// --- Function to get options for the Main Chart ---
// Adds the 'todayLine' plugin config
export const getMainChartOptions = (todayIndex, shortermEndDayIndex, todayString) => ({
    ...commonOptions, // Inherit common settings (incl. dynamic axes)
    plugins: {
     ...commonOptions.plugins, // Inherit common plugin configs
     title: {
      display: true,
      text: 'Full Season',
      font: {
       family: 'Saira',
       size: 24,
       weight: 'bold ',
      },
      color: 'rgba(36, 43, 122, 1)'
     },
     todayLine: { // Add specific config for the 'todayLine' plugin
      todayDataIndex: todayIndex,
      shortermEndDayIndex: shortermEndDayIndex, // Pass the new index
      lineColor: 'rgba(36, 43, 122, 0.7)',
      lineWidth: 2,
      lineDash: [6, 3],
      label: 'Today', //  Label for the line
      showInLegend: true, //  New option to control legend visibility
      labelFontColor: 'rgba(36, 43, 122, 0.7)',
      labelFontSize: 10,
      labelOffset: 8
     }
    }
   });

// --- Function to get options for the Bottom Charts ---
// Sets synced Y and Y1 axes using suggestedMax for nice ticks
export const getBottomChartsOptions = (suggestedMaxY, suggestedMaxY1, graphtitle) => ({
    ...commonOptions, // Inherit common settings
    scales: {
        ...commonOptions.scales, // Inherit x-axis config
        y: { // Override y-axis from commonOptions
            ...commonOptions.scales.y,
            suggestedMax: suggestedMaxY // Use suggestedMax for synced, nice ticks
        },
        y1: { // Override y1-axis from commonOptions
             ...commonOptions.scales.y1,
            suggestedMax: suggestedMaxY1 // Use suggestedMax for synced, nice ticks
        }
    },
    plugins: {
        ...commonOptions.plugins, // Inherit common plugin configs
        title: {
            display: true,
            text: graphtitle,
            font: {
                family: 'Saira',
                size: 24,
                // weight: 'bold ',
            },
            color: 'rgba(36, 43, 122, 1)'
        },
    }
});